import { Grid, TablePagination, Typography } from '@mui/material';
import React from 'react';
import Button from '../UI/Button';
import TablePaginationActions from '../../shared/components/Table/Actions';
import CheckCircle from '@mui/icons-material/CheckCircle';
import Cancel from '@mui/icons-material/Cancel';
import { green } from '@mui/material/colors';
import { red } from '@mui/material/colors';

const VotacaoUsuarioTable = ({ pageVotacaoUsuario, handleChangePage, setVotacaoUsuario }) => {
    return (
        <>
            <Grid container spacing={3}>

                {pageVotacaoUsuario.totalElements > 0 ?
                    <>
                        {pageVotacaoUsuario.content.map((votacaoUsuario) => (
                            <Grid
                                style={{
                                    border: '1px solid black',
                                    borderRadius: '20px'
                                }}
                                size={12}>
                                <Grid container direction='row' justifyContent='center' alignItems='center' alignContent='center' spacing={3}>
                                    <Grid size={4}>
                                        {/* <Typography variant='h6'>Título</Typography> */}
                                        <Typography variant='body1'>
                                            {votacaoUsuario?.votacao.titulo}
                                        </Typography>
                                    </Grid>
                                    <Grid size={4}>
                                        <Typography variant='h6'>Respondido</Typography>
                                        {votacaoUsuario?.respondido ?
                                            <CheckCircle style={{ color: green[500] }} /> :
                                            <Cancel style={{ color: red[500] }} />}
                                    </Grid>
                                    <Grid size={4}>
                                        <Button
                                            onClick={() => setVotacaoUsuario(votacaoUsuario)}
                                        >
                                            Selecionar
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        ))}
                        <TablePagination
                            rowsPerPageOptions={[]}
                            rowsPerPage={pageVotacaoUsuario.size ? pageVotacaoUsuario.size : 0}
                            component="div"
                            count={pageVotacaoUsuario.totalElements}
                            page={pageVotacaoUsuario.number}
                            onPageChange={handleChangePage}
                            labelDisplayedRows={({ from, to, count }) => (from + "-" + to + " de " + (count !== -1 ? count + " registros" : + " mais de " + to))}
                            ActionsComponent={TablePaginationActions}
                        />
                    </> :
                    <Grid container justifyContent='center' alignItems='center'>
                        <Grid>
                            <Typography variant='body1'>Nenhuma Votação cadastrada...</Typography>
                        </Grid>
                    </Grid>
                }
            </Grid>
        </>
    );
}

export default VotacaoUsuarioTable;